import { PageTitleConstants } from "./PageTitleConstants";
import { RoutePathConstants } from "./RoutePathConstants";
import { PermissionConstants } from "./PermissionConstants";
import ProtectedRoute from "../Routes/ProtectedRoute";
import LoginRoute from "../Routes/LoginRoute";
import {
  Login,
  Home,
  UserList,
  Calendar,
  CalendarForm,
  QuestionAdd,
  QuestionEdit,
  QuestionList,
  PageAdd,
  PageEdit,
  PageList,
  QuestionnaireAdd,
  QuestionnaireEdit,
  QuestionnaireList,
  Survey,
  ApplicationForm,
  ContractForm,
  CompletingBalanceSheetOfModuleFirst,
  CompletingBalanceSheetOfModuleFirstByAdvisor,
  Store,
  StoreSummary,
  StoreEdit,
  StoreExclusive,
  StoreExclusiveSummary,
  CompletingBalanceSheetOfModuleSecond,
  CompletingBalanceSheetOfModuleSecondv2,
  OrderingVouchers,
  PasswordSet,
  ContractFormv2,
  Meetings,
} from "../Pages";
import ForgotPassword from "../Pages/Authentication/ForgotPassword";
import PasswordReset from "../Pages/Authentication/PasswordReset";

export const RouteConstants = {
  LoginLayout: [
    {
      path: `${RoutePathConstants.Login}`,
      titlePart: PageTitleConstants.Login,
      component: (
        <LoginRoute>
          <Login />
        </LoginRoute>
      ),
      breadcrumb: PageTitleConstants.Login,
    },
    {
      path: `${RoutePathConstants.PasswordSet}/:hash`,
      titlePart: PageTitleConstants.NewPassword,
      component: (
        <div>
          <PasswordSet />
        </div>
      ),
      breadcrumb: PageTitleConstants.NewPassword,
    },
    {
      path: `${RoutePathConstants.ForgotPassword}`,
      titlePart: PageTitleConstants.ForgotPassword,
      component: (
        <div>
          <ForgotPassword />
        </div>
      ),
      breadcrumb: PageTitleConstants.ForgotPassword,
    },
    {
      path: `${RoutePathConstants.PasswordReset}/:hash`,
      titlePart: PageTitleConstants.ResetPassword,
      component: (
        <div>
          <PasswordReset />
        </div>
      ),
      breadcrumb: PageTitleConstants.PasswordReset,
    },
  ],
  MainLayout: [
    {
      path: ``,
      titlePart: PageTitleConstants.Home,
      component: (
        <ProtectedRoute validateStep={false}>
          <Home />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.Home,
    },
    {
      path: `${RoutePathConstants.Survey}`,
      titlePart: PageTitleConstants.Survey,
      component: (
        <ProtectedRoute validateStep={true}>
          <Survey />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.Survey,
    },
    {
      path: `${RoutePathConstants.ApplicationForm}`,
      titlePart: PageTitleConstants.ApplicationForm,
      component: (
        <ProtectedRoute validateStep={true}>
          <ApplicationForm />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.ApplicationForm,
    },
    {
      path: `${RoutePathConstants.ContractForm}`,
      titlePart: PageTitleConstants.ContractForm,
      component: (
        <ProtectedRoute validateStep={true}>
          <ContractForm />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.ContractForm,
    },
    {
      path: `${RoutePathConstants.ContractFormv2}`,
      titlePart: PageTitleConstants.ContractFormv2,
      component: (
        <ProtectedRoute validateStep={true}>
          <ContractFormv2 />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.ContractFormv2,
    },
    {
      path: `${RoutePathConstants.CompletingBalanceSheetOfModuleFirst}`,
      titlePart: PageTitleConstants.CompletingBalanceSheetOfModuleFirst,
      component: (
        <ProtectedRoute validateStep={true}>
          <CompletingBalanceSheetOfModuleFirst />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.CompletingBalanceSheetOfModuleFirst,
    },
    {
      path: `${RoutePathConstants.CompletingBalanceSheetOfModuleFirstByAdvisor}`,
      titlePart:
        PageTitleConstants.CompletingBalanceSheetOfModuleFirstByAdvisor,
      component: (
        <ProtectedRoute validateStep={true}>
          <CompletingBalanceSheetOfModuleFirstByAdvisor />
        </ProtectedRoute>
      ),
      breadcrumb:
        PageTitleConstants.CompletingBalanceSheetOfModuleFirstByAdvisor,
    },
    {
      path: `${RoutePathConstants.Store}`,
      titlePart: PageTitleConstants.Store,
      component: (
        <ProtectedRoute validateStep={true}>
          <Store />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.Store,
    },
    {
      path: `${RoutePathConstants.StoreSummary}`,
      titlePart: PageTitleConstants.StoreSummary,
      component: (
        <ProtectedRoute validateStep={true}>
          <StoreSummary />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.StoreSummary,
    },
    {
      path: `${RoutePathConstants.StoreExclusive}/:uuId`,
      titlePart: PageTitleConstants.StoreExclusive,
      component: (
        <ProtectedRoute validateStep={true}>
          <StoreExclusive />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.StoreExclusive,
    },
    {
      path: `${RoutePathConstants.StoreExclusiveSummary}/:uuId`,
      titlePart: PageTitleConstants.StoreExclusiveSummary,
      component: (
        <ProtectedRoute validateStep={true}>
          <StoreExclusiveSummary />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.StoreExclusiveSummary,
    },
    {
      path: `${RoutePathConstants.StoreEdit}`,
      titlePart: PageTitleConstants.StoreEdit,
      component: (
        <ProtectedRoute validateStep={true}>
          <StoreEdit />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.StoreEdit,
    },
    {
      path: `${RoutePathConstants.CompletingBalanceSheetOfModuleSecond}`,
      titlePart: PageTitleConstants.CompletingBalanceSheetOfModuleSecond,
      component: (
        <ProtectedRoute validateStep={true}>
          <CompletingBalanceSheetOfModuleSecond />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.CompletingBalanceSheetOfModuleSecond,
    },
    {
      path: `${RoutePathConstants.CompletingBalanceSheetOfModuleSecondv2}`,
      titlePart: PageTitleConstants.CompletingBalanceSheetOfModuleSecondv2,
      component: (
        <ProtectedRoute validateStep={true}>
          <CompletingBalanceSheetOfModuleSecondv2 />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.CompletingBalanceSheetOfModuleSecondv2,
    },
    {
      path: `${RoutePathConstants.OrderingVouchers}`,
      titlePart: PageTitleConstants.OrderingVouchers,
      component: (
        <ProtectedRoute validateStep={true}>
          <OrderingVouchers />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.OrderingVouchers,
    },
    {
      path: `${RoutePathConstants.User}`,
      titlePart: PageTitleConstants.UserList,
      component: (
        <ProtectedRoute requiredPermissions={[PermissionConstants.User_List]}>
          <UserList />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.UserList,
    },
    {
      path: `${RoutePathConstants.Calendar}`,
      titlePart: PageTitleConstants.Calendar,
      component: (
        <ProtectedRoute requiredPermissions={[PermissionConstants.Calendar]}>
          <Calendar />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.Calendar,
    },
    {
      path: `${RoutePathConstants.CalendarForm}`,
      titlePart: PageTitleConstants.CalendarForm,
      component: (
        <ProtectedRoute requiredPermissions={[PermissionConstants.Calendar]}>
          <CalendarForm />
        </ProtectedRoute>
      ),
      breadcrumb:
        PageTitleConstants.Calendar + "/" + PageTitleConstants.CalendarForm,
    },
    {
      path: `${RoutePathConstants.Question}`,
      titlePart: PageTitleConstants.QuestionList,
      component: (
        <ProtectedRoute requiredPermissions={[PermissionConstants.User_List]}>
          <QuestionList />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.QuestionList,
    },
    {
      path: `${RoutePathConstants.Questionnaire}/:questionnaireId/:pageId`,
      titlePart: PageTitleConstants.QuestionList,
      component: (
        <ProtectedRoute requiredPermissions={[PermissionConstants.User_List]}>
          <QuestionList />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.QuestionList,
    },
    {
      path: `${RoutePathConstants.Question}/${RoutePathConstants.Add}`,
      titlePart: PageTitleConstants.QuestionAdd,
      component: (
        <ProtectedRoute requiredPermissions={[PermissionConstants.User_List]}>
          <QuestionAdd />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.QuestionAdd,
    },
    {
      path: `${RoutePathConstants.Question}/${RoutePathConstants.Edit}/:id`,
      titlePart: PageTitleConstants.QuestionEdit,
      component: (
        <ProtectedRoute requiredPermissions={[PermissionConstants.User_List]}>
          <QuestionEdit />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.QuestionEdit,
    },
    {
      path: `${RoutePathConstants.Questionnaire}`,
      titlePart: PageTitleConstants.QuestionnaireList,
      component: (
        <ProtectedRoute requiredPermissions={[PermissionConstants.User_List]}>
          <QuestionnaireList />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.QuestionnaireList,
    },
    {
      path: `${RoutePathConstants.Questionnaire}/${RoutePathConstants.Add}`,
      titlePart: PageTitleConstants.QuestionnaireAdd,
      component: (
        <ProtectedRoute requiredPermissions={[PermissionConstants.User_List]}>
          <QuestionnaireAdd />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.QuestionnaireAdd,
    },
    {
      path: `${RoutePathConstants.Questionnaire}/${RoutePathConstants.Edit}/:id`,
      titlePart: PageTitleConstants.QuestionnaireEdit,
      component: (
        <ProtectedRoute requiredPermissions={[PermissionConstants.User_List]}>
          <QuestionnaireEdit />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.QuestionnaireEdit,
    },
    {
      path: `${RoutePathConstants.Page}`,
      titlePart: PageTitleConstants.PageList,
      component: (
        <ProtectedRoute requiredPermissions={[PermissionConstants.User_List]}>
          <PageList />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.PageList,
    },
    {
      path: `${RoutePathConstants.Questionnaire}/:questionnaireId`,
      titlePart: PageTitleConstants.PageList,
      component: (
        <ProtectedRoute requiredPermissions={[PermissionConstants.User_List]}>
          <PageList />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.PageList,
    },
    {
      path: `${RoutePathConstants.Questionnaire}/:id/${RoutePathConstants.Add}`,
      titlePart: PageTitleConstants.PageAdd,
      component: (
        <ProtectedRoute requiredPermissions={[PermissionConstants.User_List]}>
          <PageAdd />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.PageAdd,
    },
    {
      path: `${RoutePathConstants.Page}/${RoutePathConstants.Add}`,
      titlePart: PageTitleConstants.PageAdd,
      component: (
        <ProtectedRoute requiredPermissions={[PermissionConstants.User_List]}>
          <PageAdd />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.PageAdd,
    },
    {
      path: `${RoutePathConstants.Page}/${RoutePathConstants.Edit}/:id`,
      titlePart: PageTitleConstants.PageEdit,
      component: (
        <ProtectedRoute requiredPermissions={[PermissionConstants.User_List]}>
          <PageEdit />
        </ProtectedRoute>
      ),
      breadcrumb: PageTitleConstants.PageEdit,
    },
    {
      path: RoutePathConstants.Meetings,
      titlePart: PageTitleConstants.Meetings,
      component: (
          <Meetings />
      ),
    }
  ],
};
